import type { PlatformErrorAreas } from "$root/api/error-reporting";
import { DropdownMenu,type DropdownMenuProps } from "@mdotm/shadcn/mdotm/components";
import { DownloadTrigger } from "./DropdownMenuTrigger";

export function PageDownloadMenu(props: {
	actions: DropdownMenuProps["actions"];
	area: PlatformErrorAreas;
}): React.JSX.Element {
	return (
		<DropdownMenu
			actions={props.actions}
			Trigger={DownloadTrigger}
			extraTriggerProps={{ "data-qualifier": `PageDownloadMenu(${props.area})/Button` }}
		/>
	);
}
